"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DotPath = void 0;
class DotPath {
    constructor(path) {
        this.paths = path.split('.');
    }
    toString() {
        return this.paths.join('.');
    }
    navigate(object) {
        let nextStep = object;
        for (const prop of this.paths) {
            if (nextStep) {
                nextStep = nextStep[prop];
            }
        }
        return nextStep;
    }
    navigateAndSet(object, value) {
        let nextStep = object;
        let index = 0;
        const steps = this.paths.length;
        for (const prop of this.paths) {
            ++index;
            if (nextStep) {
                if (index === steps) {
                    nextStep[prop] = value;
                    break;
                }
                if (!nextStep[prop]) {
                    nextStep[prop] = {};
                }
                nextStep = nextStep[prop];
            }
        }
    }
}
exports.DotPath = DotPath;
//# sourceMappingURL=dot-path.js.map